module.exports = __webpack_public_path__ + "static/img/appendix.efad94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appendix.png
// module id = cm+d
// module chunks = 0